// Block envelope —— 所有消息块的统一外壳
import { z } from "zod";

export const SenderKindSchema = z.enum(["human", "agent"]);
export type SenderKind = z.infer<typeof SenderKindSchema>;

export const SenderSchema = z.object({
  id: z.string(),
  kind: SenderKindSchema,
  label: z.string().optional(),
});
export type Sender = z.infer<typeof SenderSchema>;

/**
 * 顶层 block 信封。`body` 是 unknown 占位，渲染器根据 `type` 字段选择
 * 具体 body schema 进一步 `.parse()`。未知 type 不会 fail，
 * 仅 typed 解码不可用。
 */
export const BlockSchema = z.object({
  v: z.literal(1),
  id: z.string(),
  room_id: z.string(),
  sender: SenderSchema,
  ts: z.number().int().nonnegative(),
  parent_id: z.string().optional(),
  type: z.string(),
  body: z.unknown(),
  ext: z.unknown().optional(),
  sig: z.string().optional(),
});
export type Block = z.infer<typeof BlockSchema>;

export const PROTOCOL_VERSION = 1 as const;

export const KNOWN_BLOCK_TYPES = [
  "text",
  "terminal-stream",
  "code-diff",
  "approval-card",
  "embed-html",
  "task-card",
  "file-card",
  "x-custom",
] as const;

export type KnownBlockType = (typeof KNOWN_BLOCK_TYPES)[number];

export function isKnownBlockType(t: string): t is KnownBlockType {
  return (KNOWN_BLOCK_TYPES as readonly string[]).includes(t);
}

/**
 * 用指定 body schema 解析 block.body。
 * 调用者应根据 `block.type` 选择匹配的 schema。
 */
export function parseBody<T>(block: Block, schema: z.ZodType<T>): T {
  return schema.parse(block.body);
}
